
import ReactDOM from "react-dom";
import { result } from "lodash";
import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useContext,
} from "react";
import {
  useInfiniteQuery,
  QueryClient,
  QueryClientProvider,
  useQuery,
} from "react-query";

import UserItem from "./UserItem";
import SpinnerLoading from "../Spinner/SpinnerLoading";
import ScrollManager from "../ScrollManager/ScrollManager";
import ErrorLoadData from "../Error/ErrorLoadData";
import Header from "../Header/Header";
import { Context } from "../Context/Context";
import { post } from "../http/http";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      refetchOnReconnect: false,
      retry: false,
      keepPreviousData: true,
      staleTime: Infinity,
      cacheTime: Infinity,
    },
  },
});

export default function Users() {
  const {searchUser, setSearchUser} = useContext(Context); //for search

  return (
    <>
        <QueryClientProvider client={queryClient}>
          <div className="list_parent">
            <Header
              searchValue={searchUser}
              setSearch={setSearchUser}
              title={"لیست کاربران"}
              placeholderInputSearch={"جستجوی کاربر با شماره همراه"}
            />
            <div className="list">
              <ScrollManager scrollKey="users" />
              <Records/>
            </div>
          </div>
        </QueryClientProvider>
    </>
  );
}

///////////////

const Records = () => {
  const {lastIdUser , searchUser} = useContext(Context)

  function handleRefresh() {
    queryClient.resetQueries("users_repoData");
  }
  const request = { mobile: searchUser, last_id: lastIdUser.current };
  const {
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    data,
    status,
    error,
    isError,
  } = useInfiniteQuery(
    ["users_repoData", searchUser],
    ({ pageParam = 1, signal }) =>
      post(`/api/admin/users/index?page=${pageParam}`, request, {
        signal: signal,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage && lastPage.length > 0) {
          lastIdUser.current = lastPage[lastPage.length - 1].id;
        }
        return lastPage.length ? allPages.length + 1 : undefined;
      },
    }
  );

  const intObserver = useRef();
  const lastPostRef = useCallback(
    (post) => {
      if (isFetchingNextPage) return;
      if (intObserver.current) intObserver.current.disconnect();
      intObserver.current = new IntersectionObserver((posts) => {
        if (posts[0].isIntersecting && hasNextPage) {
          console.log("We are near the last post!");
          fetchNextPage();
        }
      });

      if (post) intObserver.current.observe(post);
    },
    [isFetchingNextPage, fetchNextPage, hasNextPage]
  );

  const content = data?.pages.map((pg) => {
    return pg.map((item, index) => {
      if (pg.length === index + 1) {
        return (
          <UserItem
            ref={lastPostRef}
            key={item.id}
            index={index}
            item={item}
            mobile={searchUser}
            queryClient={queryClient}
          />
        );
      }
      return (
        <UserItem
          key={item.id}
          index={index}
          item={item}
          mobile={searchUser}
          queryClient={queryClient}
        />
      );
    });
  });

  return (
    <div>
      {content}

      {isLoading && <SpinnerLoading />}
      {isFetchingNextPage &&
        data.pages[data.pages.length - 1].length >= 100 && <SpinnerLoading />}

      {isFetching && !isFetchingNextPage && <SpinnerLoading />}

      {isLoading == false && data && Object.keys(data.pages[0]).length < 1 && (
        <div className="empty_container">
          <div className="inner">
            <p className="empty">متأسفانه موردی پیدا نشد !</p>
          </div>
        </div>
      )}
      {isError && <ErrorLoadData func={handleRefresh} />}
    </div>
  );
};

export function useQueryClientUsers() {
  return [queryClient];
}
